<template>
  <div>
    <search-bar
      @search="onSearch"
      name="dd_prodcode,pr_detail,pr_orispeccode"
      placeholder="输入产品进行查找"
      ref="searchBar"
    />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <div class="weui-cell" v-for="item in items" :key="item.pr_code">
        <div class="weui-cell__bd">
          <p>{{item.dd_prodcode}} {{item.pr_detail}}</p>
          <p class="list-item-muted" v-if="item.pr_orispeccode">{{item.pr_orispeccode}}</p>
          <p class="list-item-muted" v-if="item.pr_spec">{{item.pr_spec}}</p>
        </div>
        <div class="weui-cell__ft">
          <p>
            <span v-format="'#,##0.#'">{{item.qty}}</span>
            &nbsp;{{item.pr_unit}}
          </p>
          <span class="list-item-status" v-if="item.pr_brand">{{item.pr_brand}}</span>
        </div>
      </div>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}张</label>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    ScrollList
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/make/report/makeCutInProcess"
    };
  },
  mounted() {
    this.doSearch()
  }
};
</script>